module.exports = __webpack_public_path__ + "img/score30.41565ef8.png";